import { TimelinePost } from '@/types/post'
import { RawCurationPost } from '@/types/curation'
import { TimelineContextType } from '@/contexts/timeline'
import { CurationContextType } from '@/contexts/curation'

export function usePostCardEdit(
  post: TimelinePost | RawCurationPost,
  timelinePost: TimelinePost,
  timelineContext: TimelineContextType | undefined,
  curationContext: CurationContextType | undefined
) {
  const handleEditSuccess = (updatedPost: TimelinePost) => {
    if (timelineContext) {
      timelineContext.updatePost(timelinePost.id, {
        territories: updatedPost.territories,
        contexts: updatedPost.contexts,
        properties: {
          ...timelinePost.properties,
          description: updatedPost.properties?.description
        },
        metadata: {
          ...timelinePost.metadata,
          description: updatedPost.metadata?.description
        }
      })
    } else if (curationContext && 'post_territory' in post) {
      const rawPost = post as RawCurationPost
      curationContext.updatePost(timelinePost.id, {
        ...rawPost,
        post_territory: updatedPost.territories?.map((id: string) => ({ territory_id: id })) || [],
        properties: {
          ...rawPost.properties,
          description: updatedPost.properties?.description
        },
        metadata: {
          ...rawPost.metadata,
          description: updatedPost.metadata?.description
        }
      } as Partial<RawCurationPost>)
    }
  }

  return { handleEditSuccess }
}
